import React from 'react';
import { ContentfulCompetition } from '@jbhi-fi/apis/src/contentful/types';
import { ContentCardCoverImage } from '../../ContentCard';
import { CardGridCardProps } from '../../ContentCard/CardGrid/CardGrid';
import { format } from 'date-fns';
import { CardTransformer } from './CardTransformer';
import { QuickSearchContentProps } from '../../QuickSearchContent/QuickSearchContent';
import { AssetTransformer } from './AssetTransformer';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';

const contentfulSpaceIdNZ = 'ck9jtoelxwa6';

export abstract class CompetitionTransformer {
  static toCardProps = (entry?: ContentfulCompetition): CardGridCardProps => {
    const coverImageProps = CardTransformer.toCardCoverImageProps(entry);
    return {
      heading: entry?.fields?.heading,
      cover: coverImageProps ? <ContentCardCoverImage {...(coverImageProps ?? {})} /> : null,
      tagProps: CardTransformer.toTagProps(entry),
      footerProps: {
        leftContent: (
          <>
            <span style={{ fontWeight: 'bold' }}>Competition closes </span>
            <span>{this.toCloseDate(entry)}</span>
          </>
        ),
      },
      showTag: false,
      href: CardTransformer.toHref(entry),
    };
  };

  static toQuickSearchCardProps = (entry?: ContentfulCompetition): QuickSearchContentProps => {
    const coverImageProps = AssetTransformer.toContentfulImageProps(entry?.fields?.heroImage);
    return {
      title: entry?.fields?.heading || '',
      image: <ContentfulImage {...coverImageProps} sizes="80px" aspectRatio={1} />,
      destinationUrl: CardTransformer.toHref(entry),
    };
  };

  static toCloseDate = (entry?: ContentfulCompetition): string => {
    const isNewZealand = entry?.sys.space?.sys.id === contentfulSpaceIdNZ;
    return entry?.fields?.endDate
      ? `${format(new Date(entry?.fields.endDate), 'hh:mmaaaa d MMM yyyy').replace(/\./g, '')} ${
          isNewZealand ? '(NZST)' : '(AEST)'
        }`
      : 'TBC';
  };
}
